import { useAuth } from "@/contexts/AuthContext";
import { canAccessDashboard } from "@/common/featureFlags";

export const useHasDashboardAccess = (): boolean => {
  const { user } = useAuth();
  return canAccessDashboard(user);
};
